import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { NullableAppointmentDetails } from 'types/types';
import { IntakeSubmissionStatusDTO } from 'artifacts/dtos';

const initialState = null as NullableAppointmentDetails;

export const appointmentSlice = createSlice({
  name: 'appointment',
  initialState,
  reducers: {
    appointmentAction: (state, action: PayloadAction<any>) => action.payload,
    appointmentIntakeStatusAction: (
      state,
      action: PayloadAction<Partial<IntakeSubmissionStatusDTO>>,
    ) => {
      const appointmentCommunique = state?.appointment?.confirmAppointmentCommunique;
      if (appointmentCommunique) {
        appointmentCommunique.intakeSubmissionStatus = {
          ...appointmentCommunique.intakeSubmissionStatus,
          ...action.payload,
        };
      }
    },
  },
});

export const { appointmentAction, appointmentIntakeStatusAction } = appointmentSlice.actions;

export default appointmentSlice.reducer;
